import { useMemo } from 'react';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';
import { createResetPasswordSchema } from '../../ui/form/helpers/createResetPasswordSchema';

export function useResetPasswordSchema() {
	const { t } = useTranslation();

	return useMemo(() => createResetPasswordSchema(t), [t]);
}
